import React from "react";
import { Button } from "@mui/material";
import { tokens } from "./tokens";

const defaultSx = {
  display: "flex",
  padding: "8px 22px",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "var(--medium, 8px)",
  background: "var(--primary-main, #536DEC)",
  boxShadow:
    "0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)",
  fontFamily: tokens.fontFamily.primary,
  fontWeight: 600,
  fontSize: 14,
  textTransform: "none",
  color: "#fff",
  "&:hover": {
    background: tokens.color.primaryHover,
    boxShadow:
      "0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)",
  },
  "&.Mui-disabled": {
    bgcolor: "rgba(0,0,0,0.12)",
    color: "rgba(0,0,0,0.38)",
    boxShadow: "none",
  },
};

/**
 * Primary (filled) button for main actions.
 * Accepts all MUI Button props; sx is merged with default styles.
 */
const PrimaryButton = ({ sx, size = "medium", disableElevation = true, ...rest }) => {
  const sizeSx =
    size === "small"
      ? { height: 36, padding: "6px 16px", fontSize: "0.875rem" }
      : {};
  return (
    <Button
      variant="contained"
      disableElevation={disableElevation}
      size={size}
      sx={{ ...defaultSx, ...sizeSx, ...sx }}
      {...rest}
    />
  );
};

export default PrimaryButton;